import React, { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router"
import { Formik, Form, Field, ErrorMessage } from "formik"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  InputGroup,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Spinner,
  Table,
} from "reactstrap"
import StoreTimes from "./StoreTimes"
import { addLocationSchema } from "components/Common/validation"
import SelectOnMap from "./SelectOnMap"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import {
  addNewBranch,
  getBranchDetails,
  updateBranch,
  updateBranchStatus,
} from "store/actions/branchsActions"
import Switch from "components/Shared/Switch"
import Spinners from "components/Shared/Spinners"
import isPermissionEnabled, {
  getSubPermissions,
} from "common/isPermissionEnabled"
import { showAlert } from "store/reducers/alertReducer"
import Breadcrumbs from "components/Common/Breadcrumb"
import BackButton from "components/Shared/BackButton"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { getCountryList } from "store/actions/countriesAction"
import Select from "react-select"
import { getAllRegionList } from "store/actions/regionAction"
import { getAllCityList } from "store/actions/cityAction"
import { get } from "helpers/api_helper"
import { GENERATE_BRANCH_ID } from "helpers/url_helper"
import {
  getImagePreviewSrc,
  handleFileChange,
} from "components/Shared/fileHandlers"
import { useTranslation } from "react-i18next"
import {
  branchHeight,
  branchMaxHeight,
  branchWidth,
} from "components/Common/ImageSize"
import imageCompression from "browser-image-compression"
import { selectedTimes } from "components/Common/constants"
import TextError from "components/Shared/TextError"

const initialValues = {
  locationNameArabic: "",
  locationNameEnglish: "",
  address: "",
  addressAr: "",
  branchId: "",
  country: "",
  latitude: "",
  longitude: "",
  preparationTimeDeliveryTime: "",
  preparationTime: "",
  baseDeliveryCharge: "",
  perKilometerAdditionalCharge: "",
  baseMaximumDistance: "",
  addressArabic: "",
  addressEnglish: "",
  telephone: "",
  pos: "",
  email: "",
  disableLocation: "",
  autoAssignLogisticsCompany1: "",
  autoAssignLogisticsCompany2: "",
  imageType: "UPLOAD",
  imageURL: "",
  imageFile: null,
  locationId: "",
  channelLinkId: "",
  countryId: "",
  regionId: "",
  cityId: "",
  thumbnailImage: "",
  thumbnailImageUrl: "",
}

const AddLocation = ({ mode }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = `${
    mode === "add" ? t("Add") : t("Edit")
  }  ${"Branch | Sign Burger"}`

  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")
  const [formValues, setFormValues] = useState(initialValues)

  const { userRole, accountType } = useSelector(state => state.Login)
  const { countryList } = useSelector(state => state.Countries)
  const { regionList } = useSelector(state => state.Region)
  const { cityList } = useSelector(state => state.City)
  const { isImageCompressing } = useSelector(state => state.Common)

  const [seprateStoreTime, setSeprateStoreTime] = useState(false)
  const [sameTimeForEachDays, setSameTimeForEachDays] = useState(false)
  const [defaultOpeningTime, setDefaultOpeningTime] = useState("00:00")
  const [defaultClosingTime, setDefaultClosingTime] = useState("23:59")

  const [isRemarkModal, setIsRemarkModal] = useState(false)
  const [remark, setRemark] = useState(null)

  const [enableObj, setEnableObj] = useState({
    // enableDelivery: false,
    enablePickup: false,
    enableCurbside: false,
    // open_24_hours: false,
    // enableInventoryUpdate: false,
    isDriveThruEnabled: false,
    // tableNumberPrompt: false,
    // ordersAvailable: false,
    // itemsNotAvailable: false,
    // enableSmoking: false,
    enableDineIn: false,
  })

  const [open_24_hours, setOpen_24_hours] = useState(false)

  const { loading, isLoading, isUpdating, branchDetails } = useSelector(
    state => state.Branchs
  )

  const [branchsPermissions, setBranchsPermissions] = useState({
    create: null,
    edit: null,
  })

  const [branchSubPermissions, setBranchSubPermissions] = useState({})

  useEffect(() => {
    const isPermissionCreate = isPermissionEnabled(
      userRole,
      5,
      "branchLocations_2",
      accountType
    )
    const isPermissionEdit = isPermissionEnabled(
      userRole,
      5,
      "branchLocations_3",
      accountType
    )

    // get sub permissions array
    const subPermissionsEdit = getSubPermissions(
      userRole,
      5,
      "branchLocations_3",
      accountType
    )

    // set sub permissions array data state
    setBranchSubPermissions(subPermissionsEdit)

    if (mode === "add") {
      if (!isPermissionCreate) {
        navigate("/dashboard")
      }
    } else if (mode === "edit") {
      if (!isPermissionEdit) {
        navigate("/dashboard")
      }
    }
    setBranchsPermissions({
      create: isPermissionCreate,
      edit: isPermissionEdit,
    })
  }, [])

  // IF HAVE MODE===EDIT THEN UPDATE INITAIL VALUES
  useEffect(() => {
    if (mode === "edit") {
      getOldValues()
    }
    fetchCountryList()
  }, [])

  const fetchCountryList = () => {
    dispatch(getCountryList())
  }

  const getOldValues = () => {
    const payload = {
      id,
    }
    dispatch(getBranchDetails(payload))
  }

  const fetchRegionList = countryId => {
    dispatch(getAllRegionList(countryId))
  }

  const fetchCityList = (countryId, regionId) => {
    const payload = {
      countryId,
      regionId,
    }
    dispatch(getAllCityList(payload))
  }

  // GET OLD VALUES WHEN HAVE
  useEffect(() => {
    if (branchDetails && !loading && mode === "edit") {
      const {
        _id,
        branchId,
        name,
        nameAr,
        address,
        addressAr,
        telephone,
        email,
        country,
        latitude,
        longitude,
        imageUrlType,
        imageUrl,
        pickupEnabled,
        curbsideEnabled,
        open24Hours,
        isDriveThruEnabled,
        openingHours,
        isOrderAvailable,
        isItemNotAvailable,
        isDineInEnabled,
        locationId,
        channelLinkId,
        countryId,
        regionId,
        cityId,
      } = branchDetails

      var updatedCountry = {}
      if (countryId) {
        updatedCountry = {
          value: countryId._id,
          label: language === "sa" ? countryId?.nameAr : countryId?.name,
          countryCode: countryId?.countryCode,
        }
      }
      const updatedRegion = transformDropdownOption(regionId)
      const updatedCity = transformDropdownOption(cityId)
      if (countryId) {
        fetchRegionList(countryId?._id)
        fetchCityList(countryId?._id, regionId?._id)
      }
      setFormValues({
        ...formValues,
        locationNameArabic: nameAr || "",
        locationNameEnglish: name || "",
        address,
        addressAr,
        branchId,
        country: country || "",
        latitude: latitude || "",
        longitude: longitude || "",
        telephone: telephone || "",
        email: email || "",
        imageType: "URL", // Set it to URL default
        imageURL: imageUrl || "",
        imageFile: imageUrl || null,
        locationId,
        channelLinkId,
        countryId: updatedCountry,
        regionId: updatedRegion,
        cityId: updatedCity,
      })

      setEnableObj({
        ...enableObj,
        enablePickup: pickupEnabled,
        enableCurbside: curbsideEnabled,
        // open_24_hours: open24Hours,
        isDriveThruEnabled: isDriveThruEnabled,
        // itemsNotAvailable: isItemNotAvailable,
        // ordersAvailable: isOrderAvailable,
        enableDineIn: isDineInEnabled,
      })
      setTimesOptions(openingHours)
      setOpen_24_hours(open24Hours)
    }
  }, [branchDetails, language])

  const transformDropdownOption = obj => {
    if (!obj) {
      return {}
    }
    return {
      value: obj._id,
      label: language === "sa" ? obj.nameAr : obj.name,
    }
  }

  const [timesOptions, setTimesOptions] = useState(selectedTimes)

  const handleSwitchChange = key => {
    setEnableObj(prevObj => ({
      ...prevObj,
      [key]: !prevObj[key],
    }))
  }

  const insertSpaces = str => {
    return str
      .replace(/([A-Z])/g, " $1")
      .trim()
      .split(" ")
      .map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1))
      .join(" ")
  }

  function convertTo24HourFormat(timeString) {
    const [time, period] = timeString.split(" ")
    const [hour, minute] = time.split(":")
    let formattedHour = parseInt(hour)

    if (period === "PM" && formattedHour !== 12) {
      formattedHour += 12
    } else if (period === "AM" && formattedHour === 12) {
      // Handle the special case when the hour is 12:00 AM
      formattedHour = 0
    }

    return `${formattedHour.toString().padStart(2, "0")}:${minute}`
  }

  const onSubmit = values => {
    const {
      locationNameArabic,
      locationNameEnglish,
      country,
      latitude,
      longitude,
      preparationTimeDeliveryTime,
      preparationTime,
      baseDeliveryCharge,
      perKilometerAdditionalCharge,
      baseMaximumDistance,
      // addressArabic,
      // addressEnglish,
      telephone,
      // pos,
      email,
      disableLocation,
      autoAssignLogisticsCompany1,
      autoAssignLogisticsCompany2,
      imageType,
      imageURL,
      imageFile,
      locationId,
      channelLinkId,
      address,
      addressAr,
      countryId,
      regionId,
      cityId,
      branchId,
      thumbnailImage,
    } = values
    // Handle form submission
    // console.log(enableObj)
    const {
      enableCurbside,
      // enableDelivery,
      isDriveThruEnabled,
      // enableInventoryUpdate,
      enablePickup,
      // itemsNotAvailable,
      // open_24_hours,
      // ordersAvailable,
      // tableNumberPrompt,
      // enableSmoking,
      enableDineIn,
    } = enableObj
    const data = new FormData()
    data.append("name", locationNameEnglish)
    data.append("nameAr", locationNameArabic)
    data.append("address", address || "")
    data.append("addressAr", addressAr || "")
    data.append("telephone", telephone)
    data.append("branchId", branchId)
    data.append("email", email)
    data.append("country", countryId?.countryCode?.toUpperCase())
    data.append("latitude", latitude)
    data.append("longitude", longitude)
    data.append("deliveryCharge", "0")
    data.append("deliveryMaximumDistance", "0")
    // data.append("deliveryEnabled", enableDelivery)
    data.append("pickupEnabled", enablePickup)
    data.append("isOrderAvailable", false)
    data.append("isItemNotAvailable", false)
    data.append("curbsideEnabled", enableCurbside)
    data.append("open24Hours", open_24_hours)
    data.append("isDriveThruEnabled", isDriveThruEnabled)
    // data.append("hasPromptForTableNumber", tableNumberPrompt)
    // data.append("isSmokingEnabled", enableSmoking)
    data.append("isDineInEnabled", enableDineIn)
    data.append("imageUrlType", imageType)
    data.append("imageUrl", imageURL)
    data.append("thumbnailImageUrl", imageType === "URL" ? imageURL : "")
    data.append("location[type]", "Point") // HAVE TO SEND POINT
    data.append("location[coordinates][]", longitude)
    data.append("location[coordinates][]", latitude)
    data.append("locationId", locationId)
    data.append("channelLinkId", channelLinkId)
    if (countryId && countryId.value) {
      data.append("countryId", countryId.value)
    }
    if (regionId && regionId.value) {
      data.append("regionId", regionId.value)
    }
    if (cityId && cityId.value) {
      data.append("cityId", cityId.value)
    }

    timesOptions.forEach((option, index) => {
      // Convert opening time to 24-hour format
      const openingTime = convertTo24HourFormat(option.openingTime)
      // Convert closing time to 24-hour format
      const closingTime = convertTo24HourFormat(option.closingTime)

      data.append(`openingHours[${index}][dayOfWeek]`, option.dayOfWeek)
      data.append(`openingHours[${index}][openingTime]`, option.openingTime)
      data.append(`openingHours[${index}][closingTime]`, option.closingTime)
      data.append(`openingHours[${index}][closed]`, option.closed)
    })
    if (imageType === "UPLOAD") {
      data.append("image", imageFile)
      data.append("thumbnailImage", thumbnailImage)
    }
    if (mode === "add") {
      dispatch(addNewBranch(data))
        .then(action => {
          const { statusCode, status, msg } = action?.payload
          if (statusCode === 200 && status) {
            dispatch(showAlert({ text: msg, type: "success" }))
            navigate(-1)
          } else {
            dispatch(showAlert({ text: msg, type: "error" }))
          }
        })
        .catch(error => {})
    } else if (mode === "edit") {
      data.append("id", id)
      dispatch(updateBranch(data))
        .then(action => {
          const { statusCode, status, msg } = action?.payload
          if (statusCode === 200 && status) {
            dispatch(showAlert({ text: msg, type: "success" }))
            navigate(-1)
          } else {
            dispatch(showAlert({ text: msg, type: "error" }))
          }
        })
        .catch(error => {})
    }
  }

  useEffect(() => {
    if (sameTimeForEachDays) {
      // If sameTimeForEachDays is true, update timesOptions with default opening and closing times
      const updatedTimesOptions = timesOptions.map(day => ({
        ...day,
        openingTime: defaultOpeningTime,
        closingTime: defaultClosingTime,
        closed: false,
      }))
      setTimesOptions(updatedTimesOptions)
    } else {
      mode === "edit"
        ? setTimesOptions(branchDetails.openingHours)
        : setTimesOptions(timesOptions)
    }
  }, [sameTimeForEachDays, defaultOpeningTime, defaultClosingTime])

  const handleSameTimeChange = (timeType, time) => {
    if (timeType === "open") {
      setDefaultOpeningTime(time)
    } else if (timeType === "close") {
      setDefaultClosingTime(time)
    }
  }

  const handleGenerateBranchRef = async setFieldValue => {
    const response = await get(GENERATE_BRANCH_ID)
    if (response && response?.statusCode === 200) {
      const { branchReference } = response?.data
      setFieldValue("branchId", branchReference)
    }
  }

  const handleEnableBranch = (id, status) => {
    const payload = {
      id,
      status: status === 1 ? "0" : "1",
    }
    if (status === 1) {
      setIsRemarkModal(true)
    } else {
      branchStatusUpdate(payload)
    }
  }

  const handleStatusUpdate = () => {
    const payload = {
      id,
      status: "0",
      remark,
    }
    branchStatusUpdate(payload)
  }
  const branchStatusUpdate = payload => {
    dispatch(updateBranchStatus(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          setIsRemarkModal(false)
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const handleThumbnailImageChange = async (event, setFieldValue) => {
    const file = event.currentTarget.files[0]
    if (file) {
      try {
        const options = {
          maxSizeMB: 0.1,
          maxWidthOrHeight: 540,
          useWebWorker: true,
        }
        const compressedFile = await imageCompression(file, options)
        setFieldValue("thumbnailImage", compressedFile)
      } catch (error) {
        setFieldValue("thumbnailImage", file)
        console.log("error")
      }
    } else {
      setFieldValue("thumbnailImage", null)
    }
  }

  // Filter keys based on accountType and branchSubPermissions
  const filteredKeys = Object.keys(enableObj).filter(key => {
    if (accountType === "superadmin") {
      return true // Show all for superadmin
    }
    if (
      (key === "enablePickup" || key === "enableCurbside") &&
      branchSubPermissions.enable_pickup_curbside?.isEnabled
    ) {
      return true
    }
    if (
      (key === "isDriveThruEnabled" || key === "enableDineIn") &&
      branchSubPermissions.enable_dine_drive_thru?.isEnabled
    ) {
      return true
    }
    return false
  })

  if (mode === "edit" && loading) return <Spinners />

  return (
    <>
      <div className="page-content  add_location_page">
        <Breadcrumbs />

        <Row>
          <Col xl={12}>
            <Card>
              <CardBody>
                <CardTitle className="mb-2 d-flex align-items-center justify-content-between">
                  <div>
                    <BackButton />
                    {mode === "add" ? t("Add Branch") : t("Edit Branch")}
                  </div>
                  {(accountType === "superadmin" ||
                    (mode === "edit" &&
                      branchsPermissions.edit &&
                      branchSubPermissions?.edit_branch_status?.isEnabled)) && (
                    <div className="d-flex align-items-center">
                      <label htmlFor="" className="pe-3 mb-0">
                        {t("Status")}
                      </label>
                      <Switch
                        onClickHandler={e => {
                          handleEnableBranch(
                            branchDetails._id,
                            branchDetails.status
                          )
                        }}
                        isChecked={branchDetails.status === 1}
                        disabled={isUpdating}
                      />
                    </div>
                  )}
                </CardTitle>
                <Formik
                  enableReinitialize={true}
                  initialValues={formValues}
                  validationSchema={addLocationSchema(mode)}
                  onSubmit={onSubmit}
                >
                  {({
                    values,
                    errors,
                    touched,
                    setFieldValue,
                    isSubmitting,
                  }) => (
                    <Form>
                      <div className="row">
                        <div
                          className={`col-lg-${
                            mode === "add" ||
                            accountType === "superadmin" ||
                            (branchSubPermissions?.edit_opening_hours
                              ?.isEnabled &&
                              branchSubPermissions?.edit_branch_name_settings
                                ?.isEnabled)
                              ? "6"
                              : "12"
                          }`}
                        >
                          {(mode === "add" ||
                            accountType === "superadmin" ||
                            (branchsPermissions.edit &&
                              branchSubPermissions?.edit_branch_name_settings
                                ?.isEnabled)) && (
                            <div className="row">
                              <div className="col-lg-6">
                                <div className="form_field">
                                  <label htmlFor="locationNameEnglish">
                                    <span className="text-danger">* </span>
                                    {t("Name(English)")}
                                  </label>
                                  <Field
                                    type="text"
                                    id="locationNameEnglish"
                                    name="locationNameEnglish"
                                    className={
                                      errors.locationNameEnglish &&
                                      touched.locationNameEnglish
                                        ? "error"
                                        : ""
                                    }
                                  />
                                  <TextError name={"locationNameEnglish"} />
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="form_field">
                                  <label htmlFor="locationNameArabic">
                                    <span className="text-danger">* </span>
                                    {t("Name(عربي)")}
                                  </label>
                                  <Field
                                    type="text"
                                    style={{ direction: "rtl" }}
                                    id="locationNameArabic"
                                    name="locationNameArabic"
                                    className={
                                      errors.locationNameArabic &&
                                      touched.locationNameArabic
                                        ? "error"
                                        : ""
                                    }
                                  />
                                  <TextError name={"locationNameArabic"} />
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="form_field">
                                  <label htmlFor="address">
                                    {t("Address(English)")}
                                  </label>
                                  <Field
                                    as="textarea"
                                    rows={1}
                                    id="address"
                                    name="address"
                                  />
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="form_field">
                                  <label htmlFor="addressAr">
                                    {t("Address(عربي)")}
                                  </label>
                                  <Field
                                    as="textarea"
                                    rows={1}
                                    style={{ direction: "rtl" }}
                                    id="addressAr"
                                    name="addressAr"
                                    className={
                                      errors.addressAr && touched.addressAr
                                        ? "error"
                                        : ""
                                    }
                                  />
                                  <TextError name={"addressAr"} />
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="form_field">
                                  <label htmlFor="branchId">
                                    {mode === "add" && (
                                      <span className="text-danger">* </span>
                                    )}
                                    {t("Branch Reference")}
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="text"
                                      id="branchId"
                                      name="branchId"
                                      readOnly
                                      className={
                                        errors.branchId && touched.branchId
                                          ? "error"
                                          : ""
                                      }
                                    />
                                    <i
                                      onClick={() =>
                                        handleGenerateBranchRef(setFieldValue)
                                      }
                                      className="bx bx-sync bg-primary g_center"
                                      style={{
                                        position: "absolute",
                                        top: "50%",
                                        transform: "translate(-50%, -50%)",
                                        right: "-20px",
                                        height: "100%",
                                        color: "#fff",
                                        fontSize: 20,
                                        padding: "5px 10px",
                                        borderRadius: "0.25rem",
                                        borderTopLeftRadius: 0,
                                        borderBottomLeftRadius: 0,
                                        cursor: "pointer",
                                      }}
                                    ></i>
                                  </div>
                                  <TextError name={"branchId"} />
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="form_field">
                                  <label htmlFor="telephone">
                                    {t("Phone Number")}
                                  </label>
                                  <Field
                                    type="text"
                                    id="telephone"
                                    name="telephone"
                                  />
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="form_field">
                                  <label htmlFor="email">{t("Email")}</label>
                                  <Field type="email" id="email" name="email" />
                                  <TextError name={"email"} />
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="form_field">
                                  <label htmlFor="">{t("Coordinates")}</label>
                                  <SelectOnMap
                                    setFieldValue={setFieldValue}
                                    t={t}
                                  />
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="form_field">
                                  <label htmlFor="latitude">
                                    <span className="text-danger">* </span>
                                    {t("Latitude")}
                                  </label>
                                  <Field
                                    type="text"
                                    id="latitude"
                                    name="latitude"
                                    className={
                                      errors.latitude && touched.latitude
                                        ? "error"
                                        : ""
                                    }
                                  />
                                  <TextError name={"latitude"} />
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="form_field">
                                  <label htmlFor="longitude">
                                    <span className="text-danger">* </span>
                                    {t("Longitude")}
                                  </label>
                                  <Field
                                    type="text"
                                    id="longitude"
                                    name="longitude"
                                    className={
                                      errors.longitude && touched.longitude
                                        ? "error"
                                        : ""
                                    }
                                  />
                                  <TextError name={"longitude"} />
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="form_field">
                                  <label htmlFor="">{t("Image Type")} </label>
                                  <Field
                                    as="select"
                                    id="imageType"
                                    name="imageType"
                                    className={`form-control ${
                                      touched.imageType && errors.imageType
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    onChange={e => {
                                      const selectedValue = e.target.value
                                      setFieldValue("imageType", selectedValue)
                                      // Reset the value of imageURL and imageFile when the image type changes
                                      setFieldValue("imageURL", "")
                                      setFieldValue("thumbnailImageUrl", "")
                                      setFieldValue("imageFile", null)
                                    }}
                                  >
                                    <option value="URL">
                                      {t("Image Url")}
                                    </option>
                                    <option value="UPLOAD">
                                      {t("Upload Image")}
                                    </option>
                                  </Field>
                                  <TextError name={"imageType"} />
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="form_field">
                                  {/* IMAGE URL */}
                                  {values.imageType === "URL" && (
                                    <div className="form_field">
                                      <label htmlFor="imageURL">
                                        <span className="text-danger">* </span>
                                        {t("URL")}
                                      </label>
                                      <Field
                                        type="text"
                                        id="imageURL"
                                        name="imageURL"
                                        className={`form-control ${
                                          touched.imageURL && errors.imageURL
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                      />
                                      <TextError name={"imageURL"} />
                                    </div>
                                  )}
                                  {/* UPLOAD IMAGE */}
                                  {values.imageType === "UPLOAD" && (
                                    <div className="form_field position-relative">
                                      <label htmlFor="imageFile">
                                        <span className="text-danger">* </span>
                                        {t("Upload Image")}
                                      </label>
                                      <input
                                        type="file"
                                        id="imageFile"
                                        name="imageFile"
                                        className={`form-control ${
                                          touched.imageFile && errors.imageFile
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        accept="image/jpeg, image/jpg, image/png"
                                        onChange={e => {
                                          handleFileChange(
                                            e,
                                            "imageFile",
                                            setFieldValue,
                                            branchWidth,
                                            branchHeight,
                                            branchMaxHeight
                                          )
                                          handleThumbnailImageChange(
                                            e,
                                            setFieldValue
                                          )
                                        }}
                                      />
                                      <TextError name={"imageFile"} />
                                      {isImageCompressing && (
                                        <Spinner
                                          color="primary"
                                          className="file_upload_btn"
                                        />
                                      )}
                                    </div>
                                  )}
                                  {getImagePreviewSrc(mode, values) && (
                                    <div className="mt-3">
                                      <img
                                        src={getImagePreviewSrc(mode, values)}
                                        alt="Preview"
                                        className="img_preview"
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>
                              <p className="pt-2">
                                {t(
                                  "Recommended dimensions: Square Image and Size should be less than or equal to {{size}} KB",
                                  {
                                    width: branchWidth,
                                    height: branchHeight,
                                    size: branchMaxHeight,
                                  }
                                )}
                              </p>

                              <div className="col-lg-6">
                                <div className="mt-2">
                                  <label htmlFor="countryId">
                                    <span className="text-danger">* </span>
                                    {t("Select Country")}
                                  </label>
                                  <Select
                                    value={values.countryId}
                                    onChange={selectedValue => {
                                      setFieldValue("countryId", selectedValue)
                                      setFieldValue("regionId", "")
                                      setFieldValue("cityId", "")
                                      fetchRegionList(selectedValue.value)
                                    }}
                                    options={countryList?.map(item => ({
                                      label:
                                        language === "sa"
                                          ? item.nameAr
                                          : item.name,
                                      value: item._id,
                                      countryCode: item.countryCode,
                                    }))}
                                    placeholder={t("Select Country")}
                                    className={`select2-selection ${
                                      touched.countryId && errors.countryId
                                        ? "danger_color_border"
                                        : ""
                                    } `}
                                  />
                                  <TextError name={"countryId"} />
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="mt-2">
                                  <label htmlFor="regionId">
                                    <span className="text-danger">* </span>
                                    {t("Select Region")}
                                  </label>
                                  <Select
                                    value={values.regionId}
                                    onChange={selectedValue => {
                                      setFieldValue("regionId", selectedValue)
                                      setFieldValue("cityId", "")
                                      fetchCityList(
                                        values.countryId.value,
                                        selectedValue.value
                                      )
                                    }}
                                    options={regionList?.map(item => ({
                                      label:
                                        language === "sa"
                                          ? item.nameAr
                                          : item.name,
                                      value: item._id,
                                    }))}
                                    placeholder={t("Select Region")}
                                    className={`select2-selection ${
                                      touched.regionId && errors.regionId
                                        ? "danger_color_border"
                                        : ""
                                    } `}
                                  />
                                  <TextError name={"regionId"} />
                                </div>
                              </div>

                              <div className="col-lg-6 mt-2 mb-2">
                                <div className="">
                                  <label htmlFor="cityId">
                                    <span className="text-danger">* </span>
                                    {t("Select City")}
                                  </label>
                                  <Select
                                    value={values.cityId}
                                    onChange={selectedValue => {
                                      setFieldValue("cityId", selectedValue)
                                    }}
                                    options={cityList?.map(item => ({
                                      label:
                                        language === "sa"
                                          ? item.nameAr
                                          : item.name,
                                      value: item._id,
                                    }))}
                                    placeholder={t("Select City")}
                                    className={`select2-selection ${
                                      touched.cityId && errors.cityId
                                        ? "danger_color_border"
                                        : ""
                                    } `}
                                  />
                                  <TextError name={"cityId"} />
                                </div>
                              </div>

                              <CardTitle className="mt-2">
                                {t("POS settings(Deliverect)")}
                              </CardTitle>

                              <div className="col-lg-6">
                                <div className="form_field">
                                  <label htmlFor="locationId">
                                    {" "}
                                    {t("Branch Id")}
                                  </label>
                                  <Field
                                    type="text"
                                    id="locationId"
                                    name="locationId"
                                  />
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="form_field">
                                  <label htmlFor="channelLinkId">
                                    {t("Channel Link Id")}
                                  </label>
                                  <Field
                                    type="text"
                                    id="channelLinkId"
                                    name="channelLinkId"
                                  />
                                </div>
                              </div>
                            </div>
                          )}

                          <div className="col-lg-12">
                            <div className="row">
                              {filteredKeys.map(key => (
                                <div className="col-6" key={key}>
                                  <div className="single_switch">
                                    <label htmlFor="">
                                      {insertSpaces(key)}
                                    </label>
                                    <Switch
                                      isChecked={enableObj[key]}
                                      onClickHandler={() =>
                                        handleSwitchChange(key)
                                      }
                                    />
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                        <div
                          className={`col-lg-${
                            mode === "add" ||
                            accountType === "superadmin" ||
                            (branchSubPermissions?.edit_opening_hours
                              ?.isEnabled &&
                              branchSubPermissions?.edit_branch_name_settings
                                ?.isEnabled)
                              ? "6"
                              : "12"
                          }`}
                        >
                          <div className="row">
                            {/* STORE TIME */}
                            {(mode === "add" ||
                              accountType === "superadmin" ||
                              (branchsPermissions.edit &&
                                branchSubPermissions?.edit_opening_hours
                                  ?.isEnabled)) && (
                              <div className="col-lg-12">
                                <div className="form_field">
                                  <label htmlFor="">
                                    {t("Do you want to open 24 hours?")}
                                  </label>
                                  <Switch
                                    onClickHandler={() => {
                                      setOpen_24_hours(!open_24_hours)
                                      setSameTimeForEachDays(false)
                                    }}
                                    isChecked={open_24_hours}
                                  />
                                </div>

                                {!open_24_hours && (
                                  <div className="form_field">
                                    <label htmlFor="">
                                      {t(
                                        "Do you want to set same time for each day?"
                                      )}
                                    </label>
                                    <Switch
                                      onClickHandler={() =>
                                        setSameTimeForEachDays(
                                          !sameTimeForEachDays
                                        )
                                      }
                                      isChecked={sameTimeForEachDays}
                                    />

                                    {sameTimeForEachDays && (
                                      <Table
                                        striped
                                        bordered
                                        hover
                                        className="same_time_for_each_day mt-3"
                                      >
                                        <thead>
                                          <tr>
                                            <th>{t("Day")}</th>
                                            <th>{t("Open")}</th>
                                            <th>{t("Close")}</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td>{t("All Days")}</td>
                                            <td>
                                              <InputGroup>
                                                <Flatpickr
                                                  className="form-control d-block"
                                                  value={defaultOpeningTime}
                                                  placeholder="Select time"
                                                  options={{
                                                    enableTime: true,
                                                    noCalendar: true,
                                                    dateFormat: "H:i",
                                                  }}
                                                  onChange={([date]) => {
                                                    const time = date
                                                      .toTimeString()
                                                      .slice(0, 5)
                                                    handleSameTimeChange(
                                                      "open",
                                                      time
                                                    )
                                                  }}
                                                />

                                                <div className="input-group-append">
                                                  <span className="input-group-text h-100">
                                                    <i className="mdi mdi-clock-outline" />
                                                  </span>
                                                </div>
                                              </InputGroup>
                                            </td>
                                            <td>
                                              <InputGroup>
                                                <Flatpickr
                                                  className="form-control d-block"
                                                  value={defaultClosingTime}
                                                  placeholder="Select time"
                                                  options={{
                                                    enableTime: true,
                                                    noCalendar: true,
                                                    dateFormat: "H:i",
                                                  }}
                                                  onChange={([date]) => {
                                                    const time = date
                                                      .toTimeString()
                                                      .slice(0, 5)
                                                    handleSameTimeChange(
                                                      "close",
                                                      time
                                                    )
                                                  }}
                                                />

                                                <div className="input-group-append">
                                                  <span className="input-group-text h-100">
                                                    <i className="mdi mdi-clock-outline" />
                                                  </span>
                                                </div>
                                              </InputGroup>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </Table>
                                    )}
                                  </div>
                                )}
                              </div>
                            )}
                            {((mode === "add" && !sameTimeForEachDays) ||
                              (accountType === "superadmin" &&
                                !sameTimeForEachDays) ||
                              (!sameTimeForEachDays &&
                                branchsPermissions.edit &&
                                branchSubPermissions?.edit_opening_hours
                                  ?.isEnabled)) && (
                              <div className="col-lg-12">
                                {seprateStoreTime ? (
                                  <div className="time_tabs my-3"></div>
                                ) : (
                                  <StoreTimes
                                    timesOptions={timesOptions}
                                    setTimesOptions={setTimesOptions}
                                    isSeprateTime={seprateStoreTime}
                                    t={t}
                                    open_24_hours={open_24_hours}
                                  />
                                )}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-12 d-flex align-items-center justify-content-end mt-2">
                          <Button
                            type="button"
                            color="secondary"
                            onClick={() => navigate(-1)}
                          >
                            {t("Cancel")}
                          </Button>
                          <Button
                            className=" mx-2"
                            color="success"
                            type="submit"
                            disabled={isLoading || isImageCompressing}
                          >
                            {mode === "add" ? t("Add") : t("Save")}
                          </Button>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      <Modal isOpen={isRemarkModal} toggle={() => setIsRemarkModal(false)}>
        <ModalHeader toggle={() => setIsRemarkModal(false)}>
          {t("Update Branch Status")}
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-lg-12">
              <div className="form_field">
                <label htmlFor="">{t("Remark")}</label>
                <textarea
                  placeholder={t("Remark")}
                  onChange={e => setRemark(e.target.value)}
                />
              </div>
            </div>

            <div className="d-flex justify-content-end mt-4">
              <Button
                color="secondary"
                type="button"
                onClick={() => setIsRemarkModal(false)}
              >
                {t("Cancel")}
              </Button>
              <Button
                color="success"
                className="ms-2"
                disabled={!remark || isUpdating}
                onClick={handleStatusUpdate}
              >
                {t("Save")}
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default AddLocation
